import { compose, lifecycle } from 'recompose';
import { List } from 'immutable';

import { withFetch } from '../entities/Entity/containers';
import { Endpoints } from '../lib/LeanLinkService';
import { WorkTypeRecord } from '../entities/records';

export const overtimeValues = new List([
  {
    id: 'one',
    type: 'one',
    name: 'Enkel övertid',
  },
  {
    id: 'two',
    type: 'two',
    name: 'Kvalificerad övertid',
  },
]);

export default compose(
  withFetch(),
  lifecycle(({
    componentWillMount() {
      const url = this.props.public ?
        Endpoints.public.resourceApi.absentReasons() : Endpoints.absentReasons();
      this.props.fetch({ url }).then((data) => {
        const absentReasonsFromBE = data.result.items.map((o) => {
          const type = o.get('id').get('type');
          const name = o.get('id').get('name');
          return {
            id: type,
            type,
            name,
          };
        }).sortBy(o => o.name);

        if (this.props.noSpecialValues) {
          this.setState({ absentReasons: absentReasonsFromBE });
        } else {
          // Add overtime values for frontend
          this.setState({ absentReasons: overtimeValues
            .concat(absentReasonsFromBE)
            .insert(
              0,
              new WorkTypeRecord({
                id: null,
                type: 'none',
                name: 'Ingen avvikelse',
              }),
            ),
          });
        }
      });
      this.setState({ absentReasons: new List() });
    },
  })),
);
